import { Component, input, Input, InputSignal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ParcelAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead
} from '../../../../../openapi';
import { CommonModule } from '@angular/common';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';

@Component({
  selector: 'app-decision-on-development-conditions-preview',
  standalone: true,
  imports: [
    CommonModule,
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DecisionDataPreviewComponent,
    LabelComponent,
    ParcelsPreviewComponent
  ],
  templateUrl: './decision-on-development-conditions-preview.component.html'
})
export class DecisionOnDevelopmentConditionsPreviewComponent {
  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public get parcels(): ParcelAppEntityApplicationRead[] {
    return this.application()?.parcels?.filter(v => v?.tag === 'parcels') || [];
  }

  public get parcels2(): ParcelAppEntityApplicationRead[] {
    return this.application()?.parcels?.filter(v => v?.tag === 'parcels2') || [];
  }
}
